/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import mixpanel from 'mixpanel-browser';
import { environment as env } from 'environments/environment';
import { LocalStorageService } from '../localstorage.service';
import _ from 'lodash';


@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  private user: any;
  private company: any;

  constructor(private localStorageService: LocalStorageService) { }

  init(): void{
    if(env?.mixpanel && env.production){
      mixpanel.init(env.mixpanel,{debug: true});
      this.user = this.localStorageService.getLocalStorage('user');
      this.company = this.localStorageService.getLocalStorage('company');
      this.initAttributes();
    }
  }

  initAttributes(): void {
    if(this.user) {
      mixpanel.identify(this.user?.user_uid);
      mixpanel.people.set({
        '$first_name': this.user['first_name'],
        '$last_name' : this.user['last_name'],
        '$email': this.user['email'],
        '$created': this.user['created_at'],
        '$company_name': this.company['company_name']
      });
    }
  }

  trackEvent(data): void {
    if(env?.mixpanel && env.production){
      if(!data){
        data = {};
    }
    if(!_.isEmpty(this.user)){
        const additional_data: any = {};
        if(this.user?.role?.role_key){
            additional_data.user_role = this.user?.role.role_key;
        }
        if(this.user.designation){
            additional_data.user_designation = this.user?.designation;
        }
        _.extend(data, additional_data);
    }
      mixpanel.track(data);
    }
  }

  reset(): void {
    if(env?.mixpanel && env.production){
      mixpanel?.reset();
    }
  }
}
